import { LineLoader } from "@components"
import PropTypes from "prop-types"

const LoadingPlaceholder = ({
  caption = "",
  classNames = "",
  icon: Icon,
}) => (
  <div className={`${classNames} relative flex flex-col items-center justify-center grow p-12 text-center border-2 border-dashed rounded-lg border-gray-300 dark:border-content2-foreground`}>
    {Icon && <Icon className="w-24 h-24 mb-2 text-indigo-800 dark:text-content2-foreground" />}
    <p className="block mb-4 text-lg font-semibold text-content2-foreground">{caption}</p>
    <LineLoader />
  </div>
)

LoadingPlaceholder.propTypes = {
  caption: PropTypes.string,
  classNames: PropTypes.string,
  icon: PropTypes.elementType,
}

export { LoadingPlaceholder }